import React, { useState } from 'react'
import BasicICon from "../../assets/icons/unitsIcons/basicData.png"
import PriceIcon from "../../assets/icons/unitsIcons/key.png"
import OptionsIcon from "../../assets/icons/unitsIcons/more options.png"
const AddUnitHooks = () => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
  
    const [search, setSearch] = useState(false)
  
  
    const NavItems = [
        { name: "Basic Data", to: "Price", icon: BasicICon  , actionText:"Basic"},
        { name: "Price", to: "Price", icon: PriceIcon , actionText:"Price"},
        { name: "More Options", to: "Price", icon: OptionsIcon , actionText:"options" },
      ];

      
  
      const [selectedTeamId, setSelectedTeamId] = useState(null);
      const [selectedTeamName, setSelectedTeamName] = useState(null);
    
      const handleSelect = (teamId) => {
        const selectedTeam = teams.find(team => team.id === teamId);
        setSelectedTeamId(teamId);
        setSelectedTeamName(selectedTeam.name);
      };
    
      const teams = [
        { id: 1, name: 'Team A' , nameAr: 'فريق ب'  },
        { id: 2, name: 'Team B'  , nameAr: 'فريق ب' },
        { id: 3, name: 'Team C'  , nameAr: 'فريق ب'}
      ];
    return {
      NavItems,
      setSearch,
      handleShow,
      show,
      handleClose,
      handleSelect,
      teams,
      selectedTeamName,
      setSelectedTeamName
    }
}

export default AddUnitHooks